// extracted by mini-css-extract-plugin
export default {"bannerItem":"HomeBanner_bannerItem__Yaztx","img":"HomeBanner_img__39BRN","content":"HomeBanner_content__XBDa9","bannerImageElement":"HomeBanner_bannerImageElement__rI+pM"};